export default "<p class=\"text-center text-success\">Zignsec Id verification is successfully completed!</p>\n";